/*
 *
 * !!! WARNING !!!
 *
 * Avoid putting database watchers in the common UserProvider, as this should be done in pathfinder instead (ie. this composable).
 * Specifically, 'RangeError: Maximum call stack size exceeded' or other exceptions may occur in common providers when the db is updated.
 * See HUNT-1778 for details.
 *
 * It's working fine for now as there are no watchers in the provider, only getters and setters.
 *
 */

import { ref } from 'vue';
import { UserProvider } from 'ihunter-common';
import { useFirebase } from './useFirebase';

const userSummary = ref({
    waypoints: '',
    tracks: '',
    drawings: '',
    contacts: '',
    layers: '',
});

let userProvider, user;

export function useUserSummary() {
    const { firebaseApp } = useFirebase();

    async function populateUserSummary(firebaseUser) {
        user = firebaseUser;
        userSummary.value.waypoints = await countUserWaypoints();
        userSummary.value.tracks = await countUserTracks();
        userSummary.value.drawings = await countUserDrawings();
        userSummary.value.layers = await countUserLayers();
        userSummary.value.contacts = await countUserContacts();
    }

    function getUserProvider() {
        if (!userProvider) {
            console.log(`Instantiating UserProvider`);
            userProvider = new UserProvider(firebaseApp);
        }
        return userProvider;
    }

    async function countUserWaypoints() {
        return await getUserProvider().countWaypoints(user.uid);
    }

    async function countUserTracks() {
        return await getUserProvider().countTracks(user.uid);
    }

    async function countUserDrawings() {
        return await getUserProvider().countDrawings(user.uid);
    }

    async function countUserLayers() {
        return await getUserProvider().countMaplayers(user.uid);
    }

    async function countUserContacts() {
        return await getUserProvider().countContacts(user.uid);
    }

    return {
        userSummary,
        populateUserSummary,
    };
}
